import React from "react"
import { Link } from "react-router-dom"

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

const YearlyReportSummaryDisabled: React.FC = () => {
  return (
    <div className="content-wrapper">
      <Container fluid>
        <Row>
          <Col xs={12} lg={10} className="main">
            <Container fluid>
              <Row className="pt-3 pb-1">
                <Col xs={8}>
                  <h4 className="underline">Jahreszusammenfassung</h4>
                </Col>
              </Row>
            </Container>
            <div className="content-wrapper">
              <p>Bitte kontaktieren Sie den <Link className="link-underline" to="/kontakt">Support</Link> oder schicken Sie uns eine
                <a className="link-underline" href="mailto:info@kva-plus.de">E-Mail</a>, wenn Sie eine Jahreszusammenfassung erhalten möchten.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default YearlyReportSummaryDisabled
